/** Catalog listing : filters options */

import { FilterOptionValue } from '@europrocurement/flexy-datatable';
import { CachedOption } from '@europrocurement/l2d-domain';
import { useSelector } from 'react-redux';
import { formatOptionsByKeys } from '../forms/options';
import {
    cachedDomainsSelector,
    cachedGroupsSelector,
    cachedOffersSelector,
    cachedOriginsSelector,
} from '../cache/selectors';

type SortDirection = 'asc' | 'desc';
type SortOption = { field: keyof FilterOptionValue; direction?: SortDirection };
type FilterSortOptions = Partial<Record<'origins' | 'offers' | 'domains' | 'groups', SortOption>>;

const sortOptions = (options: FilterOptionValue[], sort?: SortOption): FilterOptionValue[] => {
    if (!sort) return options;
    return [...options].sort((a, b) => {
        const cmp = String(a[sort.field] ?? '').localeCompare(String(b[sort.field] ?? ''), 'fr', {
            sensitivity: 'base',
        });
        return sort.direction === 'desc' ? -cmp : cmp;
    });
};

/** Select redux data and format them as options */
const useFilterOptions = (sort?: FilterSortOptions) => {
    const cachedDomains = useSelector(cachedDomainsSelector);
    const cachedOrigins = useSelector(cachedOriginsSelector);
    const cachedOffers = useSelector(cachedOffersSelector);
    const cachedGroups = useSelector(cachedGroupsSelector);

    const originOptions = formatOptionsByKeys(
        cachedOrigins ?? [],
        'id' as keyof CachedOption,
        'origine' as keyof CachedOption,
    ) as FilterOptionValue[];

    const offerOptions = formatOptionsByKeys(
        cachedOffers ?? [],
        'id' as keyof CachedOption,
        'libelle' as keyof CachedOption,
    ) as FilterOptionValue[];

    const groupOptions = formatOptionsByKeys(
        cachedGroups ?? [],
        'id' as keyof CachedOption,
        'libelle' as keyof CachedOption,
    ) as FilterOptionValue[];

    const domainOptions = formatOptionsByKeys(
        cachedDomains ?? [],
        'id' as keyof CachedOption,
        'libelle' as keyof CachedOption,
    ) as FilterOptionValue[];

    return {
        origins: sortOptions(originOptions, sort?.origins),
        offers: sortOptions(offerOptions, sort?.offers),
        domains: sortOptions(domainOptions, sort?.domains),
        groups: sortOptions(groupOptions, sort?.groups),
    };
};
export default useFilterOptions;
